import { DeliveryStatus } from '@synergy/models';
import { Grid, Stack } from '@mui/material';
import { ReactElement } from 'react';

import { ArticleDetailDeliveryActions } from './article-detail-delivery-actions';
import { ArticleDetailPackingUnits } from './article-detail-packing-units';
import { ArticleDetailPriceContainer } from './article-detail-price-container';
import { ArticleDetailScalePrices } from './article-detail-scale-prices';
import { ArticleDetailSupplierImage } from './article-detail-supplier-image';
import { ArticleDetailTitle } from './article-detail-title';
import { ArticleDetailVariants } from './article-detail-variants';
import { useArticleDetailContext } from '../article-detail';

export const ArticleDetailInformation = (): ReactElement | null => {
    const { article } = useArticleDetailContext();

    return (
        <Stack gap={4} minHeight={616}>
            <ArticleDetailTitle />

            <Stack direction="row" justifyContent="space-between" columnGap={2}>
                <ArticleDetailPriceContainer />
                <ArticleDetailSupplierImage />
            </Stack>

            <Grid container={true} rowSpacing={4} columnSpacing={2}>
                {article.deliveryStatus !== DeliveryStatus.OnRequest && article.scalePrices.length > 0 && (
                    <Grid item={true} xs={12} sm={6}>
                        <ArticleDetailScalePrices />
                    </Grid>
                )}
                {article.packingUnits.length > 0 && (
                    <Grid item={true} xs={12} sm={6}>
                        <ArticleDetailPackingUnits />
                    </Grid>
                )}
                {article.variants.length > 0 && (
                    <Grid item={true} xs={12}>
                        <ArticleDetailVariants />
                    </Grid>
                )}
            </Grid>

            <Stack gap={1.5} marginTop="auto">
                <ArticleDetailDeliveryActions />
            </Stack>
        </Stack>
    );
};
